module.exports = __webpack_public_path__ + "static/media/starBackground.c182b2d9.svg";